import { useCallback } from 'react';
import { useCollectionStore } from '@/store/collection';

// Follow the Collections sort until this folder has an explicit preference.
export default function useCollectionContentSort(collectionId, contentType) {
  const sortOrder = useCollectionStore(state => (
    state.contentSortOrders[collectionId]?.[contentType] ?? state.sortOrder ?? 'newest'
  ));
  const setContentSortOrder = useCollectionStore(state => state.setContentSortOrder);
  const setSortOrder = useCallback((order) => {
    setContentSortOrder(collectionId, contentType, order);
  }, [collectionId, contentType, setContentSortOrder]);

  return [sortOrder, setSortOrder];
}
